import authService from "../services/auth/index";

export default {
  install(Vue) {
    Vue.prototype.$auth = authService;

    Vue.mixin({
      created() {
        if (this.handleSignInEvent) {
          authService.addListener("signInEvent", this.handleSignInEvent);
        }
      },

      destroyed() {
        if (this.handleSignInEvent) {
          authService.removeListener("signInEvent", this.handleSignInEvent);
        }
      }
    });
  }
};
